import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'yesno',
    standalone: false
})
export class YesnoPipe implements PipeTransform {

  transform(value: boolean): string {
    return value ? 'Yes' : 'No';
  }

}
